import { memo, useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useAuthDialog } from "@/context/auth-dialog.context";

import { WelcomeStep } from "./welcome-step";
import { SignInForm } from "./sign-in-form";
import { SignUpForm } from "./sign-up-form";
import { ResetPasswordForm } from "./reset-password-form";

type AuthStep = "welcome" | "signIn" | "signUp" | "resetPassword";

export const AuthDialog = memo(() => {
  const { isOpen, closeDialog } = useAuthDialog();
  const [activeStep, setActiveStep] = useState<AuthStep>("welcome");

  // Reset the active step to "welcome" every time the dialog opens.
  useEffect(() => {
    if (isOpen) {
      setActiveStep("welcome");
    }
  }, [isOpen]);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeDialog();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="user-layout" aria-describedby="">
        <DialogHeader>
          <DialogTitle>
            {activeStep === "welcome"
              ? "Присоединяйся к веселью!"
              : activeStep === "signIn"
              ? "Войти"
              : activeStep === "signUp"
              ? "Регистрация"
              : "Восстановление пароля"}
          </DialogTitle>
        </DialogHeader>

        {activeStep === "welcome" && (
          <WelcomeStep onSwitchStep={setActiveStep} onClose={closeDialog} />
        )}
        {activeStep === "signIn" && (
          <SignInForm onSwitchStep={setActiveStep} onClose={closeDialog} />
        )}
        {activeStep === "signUp" && (
          <SignUpForm onSwitchStep={setActiveStep} onClose={closeDialog} />
        )}
        {activeStep === "resetPassword" && (
          <ResetPasswordForm
            onSwitchStep={setActiveStep}
            onClose={closeDialog}
          />
        )}
      </DialogContent>
    </Dialog>
  );
});
